import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import IntakeForm from './components/IntakeForm/IntakeForm';
import KernelProcess from './components/KernelProcess/KernelProcess';
import KernelProcessPetrified from './components/KernelProcess/KernelProcessPetrified';
import KernelDashboard from './components/KernelDashboard/KernelDashboard';
import { submitKernel } from './utils/api';
import './styles/variables.css';
import './styles/global.css';
import './App.css';

function HomePage() {
  const navigate = useNavigate();

  const handleFormSubmit = async (formData) => {
    try {
      // Submit kernel
      const submitResponse = await submitKernel(formData);
      const newKernelId = submitResponse.kernel_id;

      // Redirect to processing page
      navigate(`/kernelprocess/${newKernelId}`);
    } catch (error) {
      console.error('Error during submission:', error);
      alert('Error: ' + error.message);
    }
  };

  return (
    <div className="app">
      <header className="app__header">
        <div className="app__header-content">
          <img src="/logo.png" alt="Arbituer" className="app__logo" />
          <div className="app__header-text">
            <h1 className="app__title">Arbituer</h1>
            <p className="app__subtitle">Market Intelligence</p>
          </div>
        </div>
      </header>

      <main className="app__main">
        <IntakeForm onSubmitComplete={handleFormSubmit} />
      </main>

      <footer className="app__footer">
        <p className="app__footer-text">
          Markets for people who reason
        </p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/kernelprocess/:kernelId" element={<KernelProcess />} />
      <Route path="/kernelprocessp/:kernelId" element={<KernelProcessPetrified />} />
      <Route path="/kernels/:kernelId" element={<KernelDashboard />} />
    </Routes>
  );
}

export default App;
